import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=2a2ccd10&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=2a2ccd10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ccd10",
  null
  
)

export default component.exports